import { ApplicationRef, EmbeddedViewRef, inject, Injectable, TemplateRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class ModalService {
  private document = inject(DOCUMENT);
  private appRef = inject(ApplicationRef);
  private openModals: { wrapper: HTMLElement; view: EmbeddedViewRef<any> }[] = [];

  open(content: TemplateRef<any>, options: { size?: string; ariaLabelledBy?: string } = {}): { close: (r?: any) => void; dismiss: (r?: any) => void } {
    const closeModal = (reason?: any) => this.removeModal(wrapper, embeddedView);
    const context = {
      $implicit: { close: closeModal, dismiss: closeModal },
      close: closeModal,
      dismiss: closeModal,
    };

    const embeddedView = content.createEmbeddedView(context);
    this.appRef.attachView(embeddedView);

    const wrapper = this.document.createElement('div');
    wrapper.className = 'modal-overlay';

    const dialog = this.document.createElement('div');
    let dialogClass = 'modal-dialog';
    if (options.size === 'lg') dialogClass += ' modal-dialog-lg';
    else if (options.size === 'xl') dialogClass += ' modal-dialog-xl';
    else if (options.size === 'sm') dialogClass += ' modal-dialog-sm';
    dialog.className = dialogClass;

    embeddedView.rootNodes.forEach((node: any) => dialog.appendChild(node));
    wrapper.appendChild(dialog);
    this.document.body.appendChild(wrapper);

    // Click backdrop to dismiss
    wrapper.addEventListener('click', (e) => {
      if (e.target === wrapper) closeModal('backdrop');
    });

    this.openModals.push({ wrapper, view: embeddedView });
    return { close: closeModal, dismiss: closeModal };
  }

  dismissAll(): void {
    [...this.openModals].forEach(({ wrapper, view }) => this.removeModal(wrapper, view));
  }

  private removeModal(wrapper: HTMLElement, view: EmbeddedViewRef<any>): void {
    this.appRef.detachView(view);
    view.destroy();
    wrapper.remove();
    this.openModals = this.openModals.filter(m => m.wrapper !== wrapper);
  }
}
